import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";

/**
 * TABLE SYSTEMCOLORS
 */
function Timezone() {
  return (
    <Crud
      title="Timezone"
      getUrl={() => "/Player/TimeZone_GetList"}
      // INSERT
      insertUrl={() => "/Player/TimeZone_Insert"}
      insertParams={({ userId }, { gmt, description }) => ({
        GMT: gmt,
        Description: description,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Player/TimeZone_Update"}
      updateParams={({ userId }, { idTimeZone, gmt, description }) => ({
        IdTimeZone: idTimeZone,
        GMT: gmt,
        Description: description,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Player/TimeZone_Delete"}
      deleteParams={({ userId }, id) => ({
        IdTimeZone: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idTimeZone"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn dataField="gmt">GMT</TableHeaderColumn>
      <TableHeaderColumn dataField="description">Timezone</TableHeaderColumn>
    </Crud>
  );
}

export default Timezone;
